<template>
  <div>
    <el-input
      class="phone-input"
      :disabled="disabled"
      :size="size"
      type="text"
      v-model="displayValue"
      @blur="isInputActive = false"
      @focus="isInputActive = true" />
  </div>
</template>

<script>
import IMask from 'imask'
let masked = IMask.createMask({
  mask: '+{62}#0-0000000000',
  definitions: {
    // <any single char>: <same type as mask (RegExp, Function, etc.)>
    // defaults are '0', 'a', '*'
    '#': /[1-9]/
  }
})

export default {
  props: {
    value: {
    },
    size: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },

  data: function () {
    return {
      isInputActive: false
    }
  },
  computed: {
    displayValue: {
      get: function () {
        if (this.value == null) return ''
        masked.unmaskedValue = this.value
        return masked.value
      },
      set: function (modifiedValue) {
        masked.value = modifiedValue
        this.$emit('input', masked.unmaskedValue)
      }
    }
  },

}

</script>

<style lang="scss">
</style>
